export const MenuItems = [
    {
      title: 'Sign In',
      path: '/api/login',
      cName: 'dropdown-link'
    },
    {
      title: 'Sign Out',
      path: '/api/logout',
      cName: 'dropdown-link'
    }
  ];